module.exports = __webpack_public_path__ + "img/20_dice[15].ce0edb54.png";